import { Role } from '@99designs/common/apps/global-nav/consts';
import { Create_viewer_user } from '__generated__/Create';

export function getRoleFromUser(user: Create_viewer_user | null): Role {
    if (!user) {
        return 'logged-out';
    } else if (user.isAdmin) {
        return 'contest-holder';
    } else if (user.isDesigner) {
        return 'designer';
    } else {
        return 'contest-holder';
    }
}
